import { TextFieldElement } from '@src/components/formFields';
import { Control } from 'react-hook-form';
import { useIntl } from 'react-intl';

interface RegexFieldProps {
    control: Control<any>;
    setDisableSave: (disable: boolean) => void;
    name: string;
    fullWidth?: boolean;
}

export function RegexField(props: RegexFieldProps) {
    const { control, setDisableSave, name, fullWidth = false } = props;
    const intl = useIntl();

    const validationRule = (value: string) => {
        let isValid = true;
        try {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const exp = new RegExp(value);
        } catch (e) {
            isValid = false;
        }
        setDisableSave(!isValid);
        return isValid;
    };

    return (
        <TextFieldElement
            control={control}
            id={name}
            name={name}
            label={intl.formatMessage({ id: 'content-type-form-regex', defaultMessage: 'Regex' })}
            validationRule={validationRule}
            helperText={intl.formatMessage({
                id: 'invalid-regex-entry',
                defaultMessage: 'the regex entered is not valid',
            })}
            fullWidth={fullWidth}
        />
    );
}
